document.addEventListener('DOMContentLoaded', () => {
  const progressPath = document.querySelector('.button__back-to-top .progress-circle path');
  if (!progressPath) return;

  const pathLength = progressPath.getTotalLength();
  progressPath.style.transition = progressPath.style.WebkitTransition = 'none';
  progressPath.style.strokeDasharray = `${pathLength} ${pathLength}`;
  progressPath.style.strokeDashoffset = pathLength;
  progressPath.getBoundingClientRect();

  let ticking = false;
  let lastProgress = null;

  function updateProgress() {
    const scroll = window.scrollY || window.pageYOffset || 0;
    const height = Math.max(1, document.documentElement.scrollHeight - window.innerHeight);
    const progress = pathLength - (scroll * pathLength) / height;
    if (progress !== lastProgress) {
      progressPath.style.strokeDashoffset = progress;
      lastProgress = progress;
    }
    ticking = false;
  }

  function requestUpdate() {
    if (ticking) return;
    ticking = true;
    window.requestAnimationFrame(updateProgress);
  }

  window.addEventListener('scroll', requestUpdate, { passive: true });
  window.addEventListener('resize', requestUpdate, { passive: true });
  window.addEventListener('load', requestUpdate, { once: true });
  requestUpdate();
});